import { render, staticRenderFns } from "./address-info.vue?vue&type=template&id=097a7535&scoped=true&"
import script from "./address-info.vue?vue&type=script&lang=js&"
export * from "./address-info.vue?vue&type=script&lang=js&"
import style0 from "./address-info.vue?vue&type=style&index=0&id=097a7535&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "097a7535",
  null
  
)

export default component.exports